import { OptionType } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { Scope } from '@fullstory/proto/fs/api/search';
import { SegmentSettings } from '@fullstory/proto/fs/services/search-settings/visualizationsettings';

export const EVERYONE_SEGMENT_ID = 'everyone';

export const DEFAULT_SEGMENT: SegmentSettings = {
  segmentId: EVERYONE_SEGMENT_ID,
  segmentScope: Scope.SCOPE_SESSION,
};

export const DEFAULT_SEGMENTS = [DEFAULT_SEGMENT];

export const DEFAULT_SEGMENT_OPTION: OptionType<string> = {
  key: 'everyone',
  value: 'everyone',
  label: intl.formatMessage({ defaultMessage: 'Everyone', id: '2XDuH4' }),
};
